import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import styles from './SharedBottomModule.scss';

const SharedBottomModuleComponent = ({ bottomModule }) => {
    if (!bottomModule || !bottomModule.length) {
        return null;
    }

    return (
        <div className={styles.wrapper}>
            {bottomModule.map(item =>
                item.title && item.description ? (
                    <>
                        <h4 className={styles.title}>{item.title}</h4>
                        <p
                            className={styles.description}
                            dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                    </>
                ) : null
            )}
        </div>
    );
};

SharedBottomModuleComponent.propTypes = {
    bottomModule: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
        })
    ),
};

export const SharedBottomModule = createFragmentContainer(SharedBottomModuleComponent, {
    bottomModule: graphql`
        fragment SharedBottomModule_bottomModule on BottomModule @relay(plural: true) {
            title
            description
        }
    `,
});
